/**
 * Returns true only for absolute http(s) URLs.
 *
 * Rejects `javascript:`, `data:`, `file:`, relative paths, and any other
 * scheme that could be used for XSS or local file access. This guard is
 * applied wherever user-supplied or backend-supplied URLs are rendered as
 * anchor hrefs (e.g. Notion deep links in zone dashboards and map popups).
 */
export function isSafeHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}
